import { render, staticRenderFns } from "./latestTxn.vue?vue&type=template&id=bd4216fa&scoped=true&"
import script from "./latestTxn.vue?vue&type=script&lang=js&"
export * from "./latestTxn.vue?vue&type=script&lang=js&"
import style0 from "./latestTxn.vue?vue&type=style&index=0&id=bd4216fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4216fa",
  null
  
)

export default component.exports